import { ExecutionRunRef, WorkflowRunWithDetails } from "@vertesia/common"

export function extractTaskName(run: ExecutionRunRef) {
    return run.tags?.find((tag) => tag.startsWith("taskName:"))?.split("taskName: ")[1] || undefined
}

export function extractSpecificTagFromExecution(run: ExecutionRunRef, tag: string) {
    return run.tags?.find((t) => t.startsWith(`${tag}:`))?.split(`${tag}:`)[1] || undefined
}

export function extractCollectionIdFromExecution(run: ExecutionRunRef) {
    return run.tags?.find((tag) => tag.startsWith("collection:"))?.split("collection:")[1] || undefined
}

export function extractCollectionId(workflow: WorkflowRunWithDetails) {
    return workflow?.input?.tags?.find((tag: string) => tag.startsWith("collection:"))?.split("collection:")[1] || undefined
}
